<template>
    <div class="wrapper wrapper-content wrapper-boxed wrapper2019">

        <div class="card has-edit">
            <div class="card-body">

                <div class="row m-t-md">
                    <div class="col-md-4 col-lg-2">
                        <a href="#" class="user-profile-img">
                            <img v-bind:src="getAvatar(user.id)" alt="" />
                        </a>
                    </div>
                    <div class="col-md-8 col-lg-10">

                        <div class="row row-clear-md-6-lg-4">
                            <div class="col-md-6 col-lg-4">
                                <div class="form-group form-group-material">
                                    <p class="control-label">First Name</p>
                                    <p class="form-control-static">{{ userFirstName }}</p>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <div class="form-group form-group-material">
                                    <p class="control-label">Last Name</p>
                                    <p class="form-control-static">{{ userSurname }}</p>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <div class="form-group form-group-material">
                                    <p class="control-label">Email Address</p>
                                    <p class="form-control-static">{{ user.email }}</p>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <div class="form-group form-group-material">
                                    <p class="control-label">User Role</p>
                                    <p class="form-control-static text-capitalize">{{ user.role ? user.role.name : '-' }}</p>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <div class="form-group form-group-material">
                                    <p class="control-label">{{ user.deleted_at ? 'Active' : 'Inactive' }}</p>
                                    <p class="form-control-static"><span class="status status-success">Active</span></p>
                                </div>
                            </div>
                        </div>

                    </div>

                </div><!-- /.row -->

            </div>

            <!-- <button type="button" class="btn btn-card-edit" data-toggle="drawer" data-target=".drawer-user-edit">
                <i class="far fa-pen"></i>
            </button> -->
        </div><!-- /.card -->
        <div v-if="(isAdmin || user.id === authorized.id) && false">
            <h2 class="card-title">Reset Password</h2>
            <div class="card">
                <div class="card-body">

                    <div class="row">
                        <div class="col-xl-4">
                            <div class="form-group form-group-material m-b-none">
                                <label class="control-label">New Password</label>
                                <input type="password" class="form-control" />
                            </div><!-- /.form-group -->
                        </div>
                        <div class="col-xl-4">
                            <div class="form-group form-group-material m-b-none">
                                <label class="control-label">Repeat New Password</label>
                                <input type="password" class="form-control" />
                            </div><!-- /.form-group -->
                        </div>
                        <div class="col-xl-4">
                            <div class="form-group form-group-material text-right m-b-none">
                                <button type="submit" class="btn btn-rounded btn-primary m-t-label">Reset Password</button>
                            </div>
                        </div>
                    </div><!-- /.row -->

                </div>
            </div><!-- /.card -->
        </div>

    </div><!-- /.wrapper -->
</template>

<script>

    import { mapState } from 'vuex'
    import {user} from 'mixins'

    export default {
        mixins: [user],

        props: [
            'id'
        ],

        data: function () {
            return {

            }
        },

        computed: {
            ...mapState('user', ['user', 'authorized']),
        }
    }
</script>
